import type { ReactNode } from 'react';

export type BadgeVariant =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'outline'
  | 'ghost';

const STYLES: Record<BadgeVariant, string> = {
  success: 'bg-success-bg text-badge-success-text',
  error: 'bg-error-bg   text-badge-error-text',
  warning: 'bg-warning-bg text-badge-warning-text',
  info: 'bg-info-bg    text-badge-info-text',
  outline: 'border border-border text-muted bg-transparent',
  ghost: 'bg-accent-faint text-text-2',
};

interface BadgeProps {
  variant?: BadgeVariant;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

export function Badge({
  variant = 'ghost',
  dot,
  children,
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11.5px] font-medium ${STYLES[variant]} ${className}`}
    >
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full shrink-0"
          style={{
            background:
              variant === 'success'
                ? 'var(--c-success)'
                : variant === 'error'
                  ? 'var(--c-error)'
                  : variant === 'warning'
                    ? 'var(--c-warning)'
                    : 'currentColor',
          }}
        />
      )}
      {children}
    </span>
  );
}
